nc_initTriggeredViewportAnimation('.module-style__fadein', 'fadeIn', '90%');
nc_initTriggeredViewportAnimation('.module-style__fadeinleft', 'fadeInLeft', '90%');
nc_initTriggeredViewportAnimation('.module-style__fadeinright', 'fadeInRight', '90%');